import { RECALL_CLASSIFICATIONS, NOTI_RECALL_STATUS, OUTPUT_DATE_FORMAT, COMMUNICATION_TYPE } from '../../../../misc/commons'
import DocumentViewModel from '../../../../components/part/shared/DocumentViewModel'
import ProviderProductTierView from '../../../share/provider-product-tier-view/index.vue'
import recallService from '../../../../services/notisphere/recall'
import { normalizeProductsFromApi } from '../../../../services/provider/communicationProduct'

export default {
    props: {
        item: {type: Object, default: null}
    },
    components: {
        DocumentViewModel,
        ProviderProductTierView
    },
    data() {
        return {
            recall_classifications: RECALL_CLASSIFICATIONS,
            recall_status: NOTI_RECALL_STATUS,
            OUTPUT_DATE_FORMAT: OUTPUT_DATE_FORMAT,
            recall: COMMUNICATION_TYPE.RECALL,
            productTierProducts: []
        }
    },
    watch: {
        item: {
            handler(item) {
                if (!item || item.communicationType !== this.recall || !item.isProviderCreated) {
                    this.productTierProducts = []
                    return
                }
                const communicationId = item.id || item.communicationId || item.communicationUID
                if (communicationId) {
                    this.fetchProviderProducts(communicationId)
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        ChangeIdentifires(fields, field, event) {
            let rownumber = field.options.filter(x => x.value == event)[0].rowNumber
            let uniquefields = fields.filter(x => x.is_unique_identifier == true && x.field_name != field.field_name)
            for (let index = 0; index < uniquefields.length; index++) {
                let uniquefield = fields.filter(x => x.is_unique_identifier == true && x.field_name == uniquefields[index].field_name)[0]
                uniquefield.selected_value = uniquefield.options.filter(x => x.rowNumber == rownumber)[0].value
            }
        },
        async fetchProviderProducts(communicationId) {
            try {
                const resp = await recallService.getProductTierData(communicationId)
                if (!resp.error && resp.data && Array.isArray(resp.data.d)) {
                    this.productTierProducts = normalizeProductsFromApi(resp.data.d)
                } else {
                    this.productTierProducts = []
                }
            } catch (e) {
                this.productTierProducts = []
            }
        },
        openLink(link) {
            window.open(link, '_blank')
        }
    }

}